module.exports = __webpack_public_path__ + "img/dsci0039.dcb5d2dc.jpg";